// A URL do VigorHub que pode ser colada para outra pessoa.
//
// Existe por causa de um link que saiu errado numa mensagem real de cobrança:
//
//   Boletos no VigorHub: http://localhost:5173/#/financeiro/rota-cobranca?rota=...
//
// A mensagem era montada com `window.location.origin`, que é a URL de QUEM
// GEROU. Quem monta a rota costuma estar no ambiente de desenvolvimento; quem
// abre está no WhatsApp, em outro aparelho, onde `localhost` é o próprio
// celular e não existe. O link não quebra na hora — quebra depois, na mão de
// quem precisava dele.
//
// Não é um erro que aparece "às vezes": é garantido sempre que alguém gerar a
// mensagem rodando `npm run dev`, e invisível para quem só testa em produção.

/** Onde o app está publicado. Último recurso, quando nada mais informa. */
export const URL_PRODUCAO = 'https://vigor-hub.vercel.app';

const semBarra = (url: string): string => String(url || '').trim().replace(/\/+$/, '');

/**
 * Origem que só existe na máquina de quem está desenvolvendo.
 *
 * Cobre `localhost`, os dois loopbacks e os IPs de rede local que o Vite imprime
 * quando roda com `--host` — esses últimos são os mais traiçoeiros, porque
 * funcionam no computador ao lado e falham no 4G do cobrador.
 */
export const ehOrigemLocal = (origin: string): boolean => {
    const o = String(origin || '').toLowerCase();
    if (!o) return true;
    return /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\]|0\.0\.0\.0)(:\d+)?$/.test(o)
        || /^https?:\/\/(10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/.test(o);
};

/**
 * Decide a base do link. Separada do `window` para poder ser testada.
 *
 * Ordem: o que o ambiente declarar (`VITE_APP_URL`) ganha — é o override para
 * quando o app roda em domínio próprio. Depois a origem atual, que cobre
 * produção e os previews da Vercel sem precisar cadastrar nada. Só quando a
 * origem é local é que se recorre ao domínio fixo: nesse caso um link para
 * produção é sempre mais útil que um link para a máquina de quem gerou.
 */
export const resolverBaseUrl = (
    origin: string | null | undefined,
    envUrl?: string | null,
): string => {
    const declarada = semBarra(String(envUrl ?? ''));
    if (declarada) return declarada;

    const atual = semBarra(String(origin ?? ''));
    if (atual && !ehOrigemLocal(atual)) return atual;

    return URL_PRODUCAO;
};

/** A base pronta para montar deep-link — sem barra no fim. */
export const baseUrlPublica = (): string => resolverBaseUrl(
    typeof window !== 'undefined' ? window.location.origin : '',
    typeof import.meta !== 'undefined' ? (import.meta as any).env?.VITE_APP_URL : undefined,
);
